import { render, staticRenderFns } from "./learn-more-dialog.vue?vue&type=template&id=4800a651"
import script from "./learn-more-dialog.vue?vue&type=script&lang=js"
export * from "./learn-more-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports